'use strict';

const settings = {
  autoplay : true,
  currentSlide: 0,
  navigator : true,
  dots : true,
  background: '#eff1f4',
  slidesInView: 1,
  swipeable: true,
  sliderTransitionTime: 2,
  direction: 'horizontal',
  border: 'none',
  thumbnails: false,
  thumbnailsInView: 3,
  transitionFlow: 'ease',
};

export default settings;
